import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { walletAPI } from "../../utils/api/WalletAPI"

const initialState = {
    walletData: [],
    status: 'idle',
    error: null,
}

export const fetchWalletDetail = createAsyncThunk(
    'wallet/fetchWalletDetail',
    async (userOrgId, { rejectWithValue }) => {
        try {
            const response = await walletAPI({ organizationId: userOrgId });
            if (!response) {
                throw new Error('No wallet data found')
            }
            return response || [];
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch wallet details')
        }
    }
)

const walletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWalletDetail.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchWalletDetail.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.walletData = action.payload;
            })
            .addCase(fetchWalletDetail.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    },
});

export default walletSlice.reducer;